import { render } from "./Follows.vue?vue&type=template&id=ef1713d2&ts=true"
import script from "./Follows.vue?vue&type=script&lang=ts"
export * from "./Follows.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__